module.exports = __webpack_public_path__ + "public/SiteImages/noInboxImage.png?543f7fad";